import { create } from 'zustand';
import ServiceUsuarios from '@/services/ServiceUsuarios';
import { notify } from '@/stores/useToast';

type Usuario = any;

interface State {
  lista: Usuario[];
  total: number;
  carregando: boolean;
  busca: string;
  setBusca: (v: string) => void;
  buscar: () => Promise<void>;
  criar: (dados: Record<string, unknown>) => Promise<void>;
  editar: (id: string, dados: Record<string, unknown>) => Promise<void>;
  bloquear: (id: string, ativo: boolean) => Promise<void>;
  resetarSenha: (email: string) => Promise<void>;
}

export const useUsuariosStore = create<State>((set, get) => ({
  lista: [],
  total: 0,
  carregando: false,
  busca: '',
  setBusca: (v) => set({ busca: v }),
  async buscar() {
    set({ carregando: true });
    try {
      const { data } = await ServiceUsuarios.listar(
        { search: get().busca || undefined },
        { skip: 0, limit: 50 },
      );
      const lista = Array.isArray(data) ? data : (data.content ?? []);
      set({
        lista,
        total: Array.isArray(data) ? lista.length : (data.totalElements ?? lista.length),
      });
    } catch {
      notify.error('Erro ao buscar usuários.');
    } finally {
      set({ carregando: false });
    }
  },
  async criar(dados) {
    try {
      await ServiceUsuarios.criar(dados);
      notify.success('Usuário criado.');
      await get().buscar();
    } catch {
      notify.error('Erro ao criar usuário.');
    }
  },
  async editar(id, dados) {
    try {
      await ServiceUsuarios.editar(id, dados);
      notify.success('Usuário atualizado.');
      await get().buscar();
    } catch {
      notify.error('Erro ao atualizar usuário.');
    }
  },
  async bloquear(id, ativo) {
    try {
      await ServiceUsuarios.bloquear(id, ativo);
      notify.success(ativo ? 'Usuário desbloqueado.' : 'Usuário bloqueado.');
      await get().buscar();
    } catch {
      notify.error('Erro ao alterar situação do usuário.');
    }
  },
  async resetarSenha(email) {
    try {
      await ServiceUsuarios.resetarSenha(email);
      notify.success('E-mail de redefinição de senha enviado.');
    } catch {
      notify.error('Erro ao enviar redefinição de senha.');
    }
  },
}));
